import { Pipe, PipeTransform } from '@angular/core';
import { TextHelper } from '../helpers/text.helper';

@Pipe({
  name: 'enumToText',
  standalone: false,
})
export class EnumToTextPipe implements PipeTransform {
  transform(pascalCase: string): string {
    return TextHelper.enumToText(pascalCase);
  }
}
